import { Container, Typography, Card, Button } from '@material-ui/core';
import { Page } from 'components';
import { useContext } from 'react';
import { Customer, Product, Dealer, Confirm } from './components';
import { newRegistrationContext, Step } from './NewRegistrationContext';


let NewRegistration = () => {
    let service = useContext(newRegistrationContext);


    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                isLoading={false}
                title="New Registration"
                subtitle={
                    <Typography>
                        In order to register a product on behalf of a customer please first check if the user exists in our database by providing his email address.<br />
                        You will be given the options to create a new account if it's not already existing.<br />
                        Once the account exists you can proceed with product registration
                    </Typography>
                }
            >
                <Card elevation={0}>
                    <Customer />
                </Card>


                {service.currentStep !== Step.Customer &&
                    <>
                        <Card style={{ marginTop: 24 }} elevation={0}>
                            <Product />
                        </Card>

                        {service.currentStep !== Step.Product &&
                            <Card style={{ marginTop: 24 }} elevation={0}>
                                <Dealer />
                            </Card>
                        }
                    </>
                }

                {service.isValidRegistration &&
                    <Button
                        style={{ marginTop: 24, marginBottom: 24, float: 'right' }}
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={service.openSummary}
                    >
                        Confirm
                    </Button>
                }

                <Confirm />
            </Page>
        </Container>
    )
}

export default NewRegistration;